import SymptomRepository from '@/shared/services/repositories/restful/symptom.repository';
import AuthRepository from '@/shared/services/repositories/restful/auth.repository';
import TrackerRepository from '@/shared/services/repositories/restful/tracker.repository';
import MyMedicationRepository from '@/shared/services/repositories/restful/my-medication.repository';
import MedicationHomeRepository from '@/shared/services/repositories/restful/medication-home.repository';
import MedicationIntakeRepository from '@/shared/services/repositories/restful/medication-intake.repository';
import NavigatorHomeRepository from './restful/navigator-home.repository';
import OnBoardingRepository from './restful/onboarding.repository';
import ChemotherapyTreatmentRepository from '@/shared/services/repositories/restful/chemotherapy-treatment.repository';
import ArticleRepository from '@/shared/services/repositories/restful/article.repository';
import PatientRepository from '@/shared/services/repositories/restful/patient.repository';
import firebaseRepository from '@/shared/services/repositories/restful/firebase.repository';

class RepositoryFactory {
  getRepository(serviceName, type = 'restful') {
    switch (serviceName) {
      case 'symptom':
        return SymptomRepository;
      case 'auth':
        return AuthRepository;
      case 'tracker':
        return TrackerRepository;
      case 'intake':
        return MedicationIntakeRepository;
      case 'my-medication':
        return MyMedicationRepository;
      case 'medication-home':
        return MedicationHomeRepository;
      case 'navigator-home':
        return NavigatorHomeRepository;
      case 'onboarding':
        return OnBoardingRepository;
      case 'chemotherapy-treatment':
        return ChemotherapyTreatmentRepository;
      case 'article':
        return ArticleRepository;
      case 'patient':
        return PatientRepository;
      case 'firebase':
        return firebaseRepository;
      default:
        throw Error(`Repository not found for service: ${serviceName}`);
    }
  }
}

export default new RepositoryFactory();
